import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { AppUserModel } from "../../infrastructure/model/AppUserModel";
import { LOCAL_STORAGE_KEY_AUTH } from "../../applications/constants/AppConst";

interface AuthContextType {
  authData: AppUserModel | null;
  setAuthData: (data: AppUserModel | null) => void;
  isAuthInitialized: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [authData, setAuthData] = useState<AppUserModel | null>(null);
  const [isAuthInitialized, setAuthInitialized] = useState(false);
  // Load authData từ localStorage khi app khởi động
  useEffect(() => {
    const storedData = localStorage.getItem(LOCAL_STORAGE_KEY_AUTH);
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        setAuthDataState(parsedData);
      } catch (error) {
        console.error("Failed to parse authData from localStorage", error);
        localStorage.removeItem(LOCAL_STORAGE_KEY_AUTH);
      }
    }
    setAuthInitialized(true);
  }, []);

  // Hàm setAuthData: vừa cập nhật state vừa lưu vào localStorage
  const setAuthDataState = (data: AppUserModel | null) => {
    if (data) {
      localStorage.setItem(LOCAL_STORAGE_KEY_AUTH, JSON.stringify(data));
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEY_AUTH);
    }
    setAuthData(data);
  };

  return (
    <AuthContext.Provider value={{ authData, setAuthData: setAuthDataState, isAuthInitialized }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    console.error("useAuth must be used within an AuthProvider");
    return {} as AuthContextType;
  }
  return context;
};
